import { AlertContext } from 'contexts/AlertContext'
import { useNavigate } from 'react-router-dom'
import { useContext, useState } from 'react'
import { POST } from 'api/request'
import * as urls from 'api/urls'

const useProfileEdit = () => {
  const [isLoading, setLoading] = useState(false)
  const { showAlert } = useContext(AlertContext)

  const navigate = useNavigate()
  const editProfile = async (qr_id: string, profile_id: string) => {
    if (isLoading) return
    setLoading(true)
    try {
      const response = await POST(urls.updatedBoard(profile_id), {
        body: { qr_id }
      })

      if (response.ok) {
        showAlert('Zaktualizowano profil!', 'success')
        navigate(`/profile/${profile_id}`)
        setLoading(false)
      } else {
        throw new Error(':/')
      }
    } catch (error) {
      setLoading(false)
      showAlert('Błąd w trakcie aktualizowania!', 'error')
    }
  }

  return {
    isEdit: isLoading,
    editProfile
  }
}

export default useProfileEdit